import { Box, Button, Link, Stack, Typography } from "@mui/material"
import { PORTFOLIO_PROJECTS } from "./projects"

export function SelectedWork() {
  return (
    <Box
      id="selected-work"
      component="section"
      sx={{
        position: "relative",
        zIndex: 2,
        scrollMarginTop: 24,
        px: { xs: 2, md: 4 },
        pt: { xs: 10, md: 14 },
        pb: { xs: 4, md: 6 },
        maxWidth: 1100,
        mx: "auto",
        pointerEvents: "auto",
      }}
    >
      <Typography
        sx={{
          letterSpacing: "0.28em",
          fontSize: "0.72rem",
          fontWeight: 700,
          color: "rgba(120,230,255,0.9)",
          mb: 1,
          textAlign: "center",
        }}
      >
        SELECTED WORK
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Instrument Serif", Georgia, serif',
          fontSize: { xs: "2.1rem", md: "3.2rem" },
          textAlign: "center",
          lineHeight: 1.05,
          mb: 1.25,
        }}
      >
        ENGINEERING. CREATIVITY. TECHNOLOGY.
      </Typography>
      <Typography
        sx={{
          textAlign: "center",
          color: "rgba(200,215,245,0.72)",
          maxWidth: 520,
          mx: "auto",
          mb: 4,
          fontSize: "0.95rem",
        }}
      >
        Three product families. Real interfaces. Captured from running applications.
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
          gap: 2,
        }}
      >
        {PORTFOLIO_PROJECTS.map((p) => (
          <Box
            key={p.id}
            sx={{
              border: "1px solid rgba(140,190,255,0.28)",
              bgcolor: "rgba(4,8,18,0.62)",
              backdropFilter: "blur(10px)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              minHeight: "100%",
            }}
          >
            <Box
              component="img"
              src={p.primary.src}
              alt={p.primary.alt}
              loading="lazy"
              sx={{
                width: "100%",
                aspectRatio: "16 / 10",
                objectFit: "cover",
                objectPosition: "top center",
                display: "block",
                borderBottom: "1px solid rgba(140,190,255,0.2)",
              }}
            />
            <Stack spacing={1.25} sx={{ p: 2, flex: 1 }}>
              <Typography
                sx={{
                  letterSpacing: "0.18em",
                  fontSize: "0.62rem",
                  fontWeight: 700,
                  color: "rgba(120,230,255,0.85)",
                }}
              >
                {p.eyebrow}
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Instrument Serif", Georgia, serif',
                  fontSize: "1.35rem",
                  lineHeight: 1.15,
                }}
              >
                {p.title}
              </Typography>
              <Typography sx={{ color: "rgba(210,225,255,0.78)", fontSize: "0.88rem", flex: 1 }}>
                {p.description}
              </Typography>
              <Button
                component={Link}
                href={`#${p.anchor}`}
                sx={{
                  alignSelf: "flex-start",
                  letterSpacing: "0.14em",
                  fontSize: "0.68rem",
                  fontWeight: 700,
                  color: "rgba(120,230,255,0.95)",
                  textDecoration: "none",
                  px: 0,
                  minWidth: 0,
                }}
              >
                {p.id === "black-velvet-records"
                  ? "EXPLORE BLACK VELVET"
                  : p.id === "gamedna"
                    ? "EXPLORE GAMEDNA"
                    : "EXPLORE BVR"}
              </Button>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
